// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
// --------------------- Import Hooks ---------------------
import { useAtualizarIndicacoesParceiros } from "../hooks/useAtualizarIndicacoesParceiros";
// --------------------- Import Styles ---------------------
import { Title } from "../../ViewGerenciarPostagens/styles";
// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

export default function ModalExcluir({
  isModalOpen,
  handleFechar,
  indicacaoId,
  buscar,
}: any) {
  // Seta o dado que irá ser atualizado
  const indicacaoData = {
    id: indicacaoId,
    active: 0,
  };
  // Chamada da função para atualizar
  const {
    atualizar,
    isLoading: isLoadingAtualizar,
    error,
    success,
    resetSuccess,
    resetError,
  } = useAtualizarIndicacoesParceiros();

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Indicação excluida com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        buscar();
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError =
        "Não foi possível excluir esta indicação, por favor tente novamente!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    navigate,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Excluir"
        onOk={() => atualizar(indicacaoData)}
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>
            <Title>Tem certeza que gostaria de excluir esta Indicação?</Title>
          </>
        }
      </Modal>
    </>
  );
}
